import { useSignInState } from "../Components/signInState";
import { useState, useCallback } from "react";
import { bffRequestHeaders } from "../services/bffFetch";

const useRevealHeaders = () => {
    const { signInState } = useSignInState();
    const [ headers, setHeaders ] = useState<{ [key: string]: string }>({});

    const getRevealHeaders = useCallback(async () => {
        if (!signInState.userInfo || signInState.isLoading) {
            setHeaders({});
            return {};
        }

        const newHeaders = bffRequestHeaders(signInState.currentCustomerID);
        setHeaders(newHeaders);
        return newHeaders;
    }, [signInState.currentCustomerID, signInState.userInfo, signInState.isLoading]);

    return { headers, getRevealHeaders };
}

export default useRevealHeaders;
